'use strict';exports.__esModule = true;var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();var _packagesConfigs = require('./packagesConfigs');function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var







Package = function () {
  function Package(_ref) {var index = _ref.index,id = _ref.id,properties = _ref.properties,period = _ref.period;_classCallCheck(this, Package);_initialiseProps.call(this);
    this.id = '' + _packagesConfigs.REALTOR_PACKAGE_ID_PREFIX + id;
    this._period = period || _packagesConfigs.PACKAGE_PERIODS.MONTH;
    this[_packagesConfigs.PROMOTIONS.PROPERTIES] = properties;
    this.index = index;
  }_createClass(Package, [{ key: 'legacyPackageDescription', get: function get()

    {
      var checked = Number(this.id.split('_').pop());
      var period = String(this._period.multiplier);

      return {
        checked: checked,
        period: period };

    } }, { key: 'packageDescription', get: function get()

    {
      var adsCount = this[_packagesConfigs.PROMOTIONS.PROPERTIES];
      var packageData = _packagesConfigs.PACKAGES_DESCRIPTION[adsCount] || {};
      return packageData[this._period.periodName] || {};
    } }, { key: 'currentPeriodValue', get: function get()

    {return this._period.value;} }, { key: 'currentPeriodKey', get: function get()

    {return this._period.label;} }, { key: 'packageNameKey', get: function get()

    {return this.id.replace(_packagesConfigs.REALTOR_PACKAGE_ID_PREFIX, '');} }, { key: 'titlePrice', get: function get()

    {return _packagesConfigs.PACKAGE_PERIODS_TITLE[this.index];} }, { key: 'oldPricePerMonth', get: function get()

    {
      var packageData = this.packageDescription;
      var oldPricePerAd = packageData.oldPriceForAdPerMonth;

      return Math.round(oldPricePerAd * this[_packagesConfigs.PROMOTIONS.PROPERTIES]);
    } }, { key: 'pricePerMonth', get: function get()

    {
      var packageData = this.packageDescription;
      var pricePerAd = packageData.priceForAdPerMonth;

      return Math.round(pricePerAd * this[_packagesConfigs.PROMOTIONS.PROPERTIES]);
    } }, { key: 'features', get: function get()

    {
      var packageData = this.packageDescription;

      return packageData.features;
    } }]);return Package;}();var _initialiseProps = function _initialiseProps() {var _this = this;this.

  changePeriod = function (period) {_this._period = period;};};exports.default =


Package;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorPackagesContainer/Package.js
// module id = 3011
// module chunks = 0